var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},[_c('button-icon-text',{staticClass:"plus btn-add",attrs:{"to":{ name: 'WatchPillsManagePillAdd' },"icon":"plus-w"}},[_vm._v(_vm._s(_vm.$t('buttons.actions.add_pill')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccddd83e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watch/pillboxV2/ButtonAddPill.vue
// module id = null
// module chunks = 